/**
 * Checkbox — primitive de contrôle checkbox (S2.5d).
 *
 * Pas de prop `label` — l'enrobage label/aria est porté par le composant
 * appelant (typiquement `<FormMultiSelect>` ou un `<Field>` boolean).
 *
 * Forward ref obligatoire pour permettre `register(name)` de RHF.
 */

import { forwardRef, type InputHTMLAttributes } from 'react'

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...rest },
  ref,
) {
  const classes = ['ui-checkbox', className].filter(Boolean).join(' ')
  return <input ref={ref} type="checkbox" className={classes} {...rest} />
})

export default Checkbox
